import React from 'react';
import { TextV2, Flex, FlexProps } from '@withjoy/joykit';
import { StyledSectionRow, StyledSectionTitleWrapper, StyledIconWrapper, StyledIcon, styles } from './styles';
import { ReactComponent as DoneCheck } from '@assets/icons/circle-check-thick.svg';
import { SkeletonThumbnail, Skeleton } from '@shared/components/Skeleton';
import { pxToRem } from '@withjoy/joykit/theme';

interface SectionProps {
  sectionTitle: string;
  completedCount: number;
  targetCount: number;
  iconUrl?: string;
}

export const Section = ({ sectionTitle, completedCount, targetCount, iconUrl }: SectionProps) => {
  const isCompleted = completedCount >= targetCount;
  return (
    <StyledSectionRow __css={styles.sectionRow}>
      <StyledSectionTitleWrapper __css={styles.sectionTitleWrapper}>
        <StyledIconWrapper
          __css={styles.iconWrapper}
          paddingY={isCompleted ? 3 : 0}
        >
          {isCompleted ? (
            <DoneCheck />
          ) : (
            <StyledIcon
              as="img"
              src={iconUrl}
            />
          )}
        </StyledIconWrapper>
        <TextV2
          textDecoration={isCompleted ? 'line-through' : 'none'}
          color={isCompleted ? 'mono8' : 'mono14'}
          typographyVariant="hed1"
        >
          {sectionTitle}
        </TextV2>
      </StyledSectionTitleWrapper>
      {!isCompleted && (
        <TextV2
          typographyVariant="body1"
          color="mono10"
        >{`${completedCount}/${targetCount}`}</TextV2>
      )}
    </StyledSectionRow>
  );
};

const SectionSkeleton = ({ ...props }: FlexProps) => {
  return (
    <StyledSectionRow
      __css={styles.sectionRow}
      {...props}
    >
      <Flex
        alignItems="center"
        height="100%"
      >
        <SkeletonThumbnail
          height={pxToRem(48)}
          width={pxToRem(48)}
          marginRight={4}
        />
        <Skeleton
          width={pxToRem(168)}
          height={pxToRem(21)}
        />
      </Flex>
      <Flex alignItems="center">
        <Skeleton
          width={pxToRem(48)}
          height={pxToRem(21)}
        />
      </Flex>
    </StyledSectionRow>
  );
};

Section.Skeleton = SectionSkeleton;
